import { ApolloCache, DefaultContext, FetchResult, MutationFunctionOptions } from "@apollo/client";
import { handleServerCartResponse } from "@/redux/slice/cart/utils/handleServerCartResponse";
import { CartInputDataV2 } from "@/components/graphql/types/globalTypes";
import { saveCartV2, saveCartV2Variables } from "@/components/graphql/types/saveCartV2";
import {
  setAllowServerUpdate,
  setCartFetchingUpdating,
  setUpdatingCart,
  setUserActionPayload,
} from "@/redux/slice/cart/slice";
import { ThunkResolvedStatus } from "@/libs/enum/ThunkResolvedStatus";

type SaveServerCartPayload = {
  dispatch: Function;
  cartInputDataV2: CartInputDataV2;
  saveCartMutation: (
    options?: MutationFunctionOptions<saveCartV2, saveCartV2Variables, DefaultContext, ApolloCache<object>>
  ) => Promise<FetchResult<saveCartV2>>;
  setIsCartFetchingUpdatingRequired?: (isCartFetchingUpdatingRequired: boolean) => void;
  isCartFetchingUpdatingRequired?: boolean;
};

export const saveServerCart = async ({
  cartInputDataV2,
  dispatch,
  saveCartMutation,
  setIsCartFetchingUpdatingRequired,
  isCartFetchingUpdatingRequired,
}: SaveServerCartPayload) => {
  if (cartInputDataV2?.patientId) {
    dispatch(setAllowServerUpdate(false));
    dispatch(setUpdatingCart(ThunkResolvedStatus.pending));

    try {
      const response = await saveCartMutation({
        variables: {
          cartInputDataV2,
        },
      });
      const saveCartResponse = response?.data?.saveCartV2;
      await handleServerCartResponse(saveCartResponse, dispatch);
      dispatch(setUpdatingCart(ThunkResolvedStatus.fulfilled));

      if (isCartFetchingUpdatingRequired) {
        dispatch(setCartFetchingUpdating(ThunkResolvedStatus.fulfilled));
        setIsCartFetchingUpdatingRequired && setIsCartFetchingUpdatingRequired(false);
      }

      localStorage.removeItem("cartItems");
    } catch (saveCartError) {
      dispatch(setUpdatingCart(ThunkResolvedStatus.rejected));
      console.error("Failed to sync server cart", saveCartError);
    } finally {
      dispatch(setUserActionPayload(null));
      dispatch(setAllowServerUpdate(true));
    }
  }
};
